const t = "routeMenu_4ecdB", e = "routeMenu__left_lxRmA", _ = "routeMenu__right_NMso1", n = "routeMenu__left__content_0cjSr", u = "routeMenu__right__content_u7Zuf", o = {
  routeMenu: t,
  routeMenu__left: e,
  routeMenu__right: _,
  routeMenu__left__content: n,
  routeMenu__right__content: u
};
export {
  o as default,
  t as routeMenu,
  e as routeMenu__left,
  n as routeMenu__left__content,
  _ as routeMenu__right,
  u as routeMenu__right__content
};
//# sourceMappingURL=routeMenu.module.scss.js.map
